import React from 'react';
import get from 'lodash/get';

const AuthField = (props) => {
	const label = "Quelle";
    const { record } = props;
    let value = get(record, "auth.ws");
	if(!value) {
		value = get(record, "auth.identifier");
	} 
    return (
        <>
            <p className="grey">{label}:</p>
            <label className={'edit'}>
                <input type="text" disabled value={value} />
            </label>
        </>
    );
};

export default AuthField;
